export default {"src":"/_next/static/media/gum-boots.9846dfe5.svg","height":168,"width":176,"blurWidth":0,"blurHeight":0};